<template>
  <article class="page page-orders page-payment">
    <section class="container-padding">
      <section>
        <h1>Payment Failed</h1>

        <FontAwesomeIcon
          :icon="faCircleXmark"
          class="mb-10 failure"
        />

        <p>We’re sorry, but your payment was not successful. Please check your payment details and try again.</p>

        <AppButton
          class="btn-solid btn-secondary"
          :processing="loadingPayFast"
          :disabled="loadingPayFast"
          @click="payNow"
        >
          Pay Now
        </AppButton>

        <AppLink
          :to="{ name: 'app_order_details', params: { order: route.params.order } }"
          class="link"
        >
          View Order
        </AppLink>
      </section>
    </section>

    <AppCopyRightInfo />
  </article>
</template>

<script setup>
import { HttpStatusCode } from 'axios';
import { ref } from 'vue';
import { useRoute } from 'vue-router';

import { AppButton, AppCopyRightInfo, AppLink } from '@/components/app';

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faCircleXmark } from '@fortawesome/pro-light-svg-icons';

import { useHttp } from '@/composables';
import config from '@/config';

const route = useRoute();

const loadingPayFast = ref(false);

const payNow = async () => {
  loadingPayFast.value = true;

  const paymentResponse = await useHttp().post('/payments', { 'order': route.params.order });

  if (paymentResponse.statusCode === HttpStatusCode.Ok) {
    const form = document.createElement('form');

    form.method = 'POST';
    form.action = config.payfastUrl;

    Object.entries(paymentResponse.data).forEach(([key, value]) => {
      const input = document.createElement('input');

      input.type = 'hidden';
      input.name = key;
      input.value = value;

      form.appendChild(input);
    });

    document.body.appendChild(form);

    form.submit();

    document.body.removeChild(form);
  } else {
    loadingPayFast.value = false;
  }
};

</script>
